module.exports = __webpack_public_path__ + "static/media/Floatie-Blue.5c5091e1.png";